import React from "react";

const Cross = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
      >
        <path
          d="M3.63638 4.84863L-0.0001697 1.21208L1.21201 -9.93665e-05L4.84856 3.63645L8.48511 -9.93665e-05L9.69729 1.21208L6.06075 4.84863L9.69729 8.48518L8.48511 9.69736L4.84856 6.06082L1.21201 9.69736L-0.0001697 8.48518L3.63638 4.84863Z"
          fill="#2F6C4F"
        />
      </svg>
    </div>
  );
};

export default Cross;
